export default "__VITE_ASSET__0d6f56dc__"